import React from "react";
import { defaultDropList, defaultAttributeList } from "../Data/WBComponentDefaults";
import { WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import WebDesigner from "../WebDesigner";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";

export default class BusinessSocialLinks extends WBComponent {
    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessSocialLinks;
        this.displayName = "Socials";
        this.dropList = defaultDropList;
        this.editList = ["bgColor","iconColor",componentAttributeTypes.multiLocation, ...defaultAttributeList, attributeTypes.gap,componentAttributeTypes.visibility];
        this.colorFields = ["bgColor","iconColor","backgroundColor"];
        this.primaryEditAttributes = ["fontSize","gap",componentAttributeTypes.multiLocation,];
        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 448 512"><path d="M448 128c0 53-43 96-96 96c-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1L279.6 321c17.6-20.2 43.5-33 72.4-33c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-6.9 .7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33c-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1c0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM352 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" /></svg>
        this.cssDefinitions =[
            new NodeCSSClassDefinition(".social-icon",
            [
                {key:"bgColor",cssProperty:"background",default:""},
                {key:"iconColor",cssProperty:"color",default:""},

             ])
        ];

        this.vagaroLink = "https://www.vagaro.com/merchants/settings/marketing/sociallink";
    
    }


    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("bgColor", "Icon Background Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("iconColor", "Icon Color", "", AttributeInputType.ColorField),
        ]
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation,siteData.businessId);
        const atts = GetNodeDomAttributes("v-business-social-links no-shrink gap-med vb-control", component, screenSize, isEditor);

        if (!isEditor)
            return <BusinessPlaceHolder node={component} dataKey={BusienssControlNames.socialLinks} layout={'1'} classNames={atts.className} />

        return <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
            <style>
                {super.GetComponentGlobalCSS(component,isEditor)}
            </style>
            <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={"1"} dataKey={BusienssControlNames.socialLinks} node={component} userContext={siteData} />
        </div>
    }

}

